import styled from "styled-components";
import { Trans } from "@coworker/locales";
import FixaButton from "../../../shared/wrappers/FixaButton/FixaButton";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 16px;
  @media (max-width: 400px) {
    padding: 8px;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  background-color: var(--grey100);
  border-radius: 8px;
  text-align: center;
  padding: 32px 16px;
  @media (min-width: 800px) {
    min-width: 700px;
  }
`;

const Description = styled.p`
  text-align: center;
`;

interface NoTableDataProps {
  title: string;
  description: string;
  resetFilters: () => void;
  titleTranslationValues?: object;
}

const NoTableData = ({
  title,
  description,
  resetFilters,
  titleTranslationValues = {},
}: NoTableDataProps) => (
  <Wrapper>
    <Container>
      <h2>
        <Trans values={titleTranslationValues}>{title}</Trans>
      </h2>
      <>
        <Description>
          <Trans>{description}</Trans>
        </Description>
        <FixaButton onClick={resetFilters}>
          <Trans>resetFiltersString</Trans>
        </FixaButton>
      </>
    </Container>
  </Wrapper>
);
export default NoTableData;
